import React, { useEffect, useState } from "react";
import { Media, VideoScript } from "@/services/bedrock";
import { RecordVideo } from ".";
import { ScreenCapture } from "../ScreenCapture";
import { Dialog } from "@/components/ui";

export type RecordVideoType = "teleprompter" | "screen";

interface Props {
  open: boolean;
  initialScript?: string;
  initialRecordVideoType: RecordVideoType;
  onVideoScriptSelected?: (script: VideoScript) => void;
  onOpenChange: (open: boolean) => void;
  onDone: (media: Media) => void;
}

const RecordVideoDialog: React.FC<Props> = ({
  open,
  initialScript,
  initialRecordVideoType,
  onVideoScriptSelected,
  onOpenChange,
  onDone,
}) => {
  const [recordVideoType, setRecordVideoType] = useState<RecordVideoType>(initialRecordVideoType);
  useEffect(() => {
    setRecordVideoType(initialRecordVideoType);
  }, [initialRecordVideoType]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange} size="full">
      <Dialog.Content>
        {recordVideoType === "teleprompter" ? (
          <RecordVideo
            initialScript={initialScript}
            onVideoScriptSelected={onVideoScriptSelected}
            onSwitchToScreenCapture={() => setRecordVideoType("screen")}
            onCancel={() => onOpenChange(false)}
            onDone={onDone}
          />
        ) : (
          <ScreenCapture
            onSwitchToTeleprompter={() => setRecordVideoType("teleprompter")}
            onCancel={() => onOpenChange(false)}
            onDone={onDone}
          />
        )}
      </Dialog.Content>
    </Dialog>
  );
};

export default RecordVideoDialog;
